import React, { useEffect } from "react";
import BackButton from "../components/BackButton";

const s = {
  wrapper: { minHeight: "100svh", background: "#f3f4f6", padding: "16px 16px 40px", boxSizing: "border-box", fontFamily: "system-ui, -apple-system, sans-serif" },
  inner: { maxWidth: "680px", margin: "0 auto" },
  card: { background: "white", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9", padding: "24px 20px" },
  h1: { fontSize: "22px", fontWeight: 800, color: "#1e293b", margin: "0 0 20px" },
  h2: { fontSize: "14px", fontWeight: 700, color: "#1e293b", marginTop: "20px", marginBottom: "6px" },
  p: { fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: "0 0 4px" },
  ul: { fontSize: "14px", color: "#475569", lineHeight: 1.7, paddingLeft: "20px", margin: "4px 0 4px" },
  a: { color: "#2563eb" },
};

const MentionsLegales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div style={s.wrapper}>
      <div style={s.inner}>
        <BackButton fallback="/" />
        <div style={s.card}>
          <h1 style={s.h1}>📜 Mentions légales – CrushNow®</h1>

          <h2 style={s.h2}>Éditeur de l'application</h2>
          <p style={s.p}><strong>CrushNow®</strong> — Application développée et éditée par :</p>
          <ul style={s.ul}>
            <li><strong>Lia Balagna-Ranin</strong></li>
            <li>Statut juridique : <strong>Éditeur de l'application</strong></li>
            <li>SIRET : <strong>en cours d'immatriculation</strong></li>
            <li>Adresse : <strong>5 square du Midi, 95000 Cergy, France</strong></li>
          </ul>
          <p style={s.p}>Marque déposée INPI n° <strong>5152773</strong></p>
          <p style={s.p}>Contact : <a href="mailto:support@crush-now.fr" style={s.a}>support@crush-now.fr</a></p>

          <h2 style={s.h2}>Hébergement</h2>
          <p style={s.p}>L'application est hébergée par :</p>
          <ul style={s.ul}>
            <li><strong>Railway Corp</strong> — 340 S Lemon Ave #4133, Walnut, CA 91789, USA — <a href="https://railway.app" style={s.a} target="_blank" rel="noopener noreferrer">railway.app</a></li>
            <li><strong>MongoDB Atlas</strong> (MongoDB Inc.) — base de données hébergée en Europe (Paris, eu-west-3) ✅</li>
            <li><strong>Firebase</strong> (Google LLC) — notifications push, hébergé aux États-Unis</li>
          </ul>
          <p style={s.p}>Ces transferts hors UE sont encadrés par les clauses contractuelles types de la Commission Européenne.</p>

          <h2 style={s.h2}>Propriété intellectuelle</h2>
          <p style={s.p}>La marque <strong>CrushNow®</strong> est protégée par l'INPI sous le numéro <strong>5152773</strong>. Tous les éléments de l'application sont protégés par le Code de la propriété intellectuelle. Toute reproduction sans autorisation écrite est interdite.</p>

          <h2 style={s.h2}>Données personnelles</h2>
          <p style={s.p}>Voir notre <a href="/privacy" style={s.a}>Politique de confidentialité</a>.</p>

          <h2 style={s.h2}>Conditions d'utilisation</h2>
          <p style={s.p}>Voir les <a href="/mentions" style={s.a}>Conditions Générales d'Utilisation</a>.</p>

          <h2 style={s.h2}>Équipe</h2>
          <p style={s.p}>CrushNow® est développé par une équipe basée en France :</p>
          <ul style={s.ul}>
            <li><strong>Lia Balagna-Ranin</strong> — Éditeur &amp; Développement</li>
            <li>Autres membres de l'équipe — à compléter</li>
          </ul>
          <p style={{ fontSize: "12px", color: "#64748b", marginTop: "8px" }}>
            Les membres de l'équipe souhaitant apparaître dans ces mentions peuvent contacter{" "}
            <a href="mailto:support@crush-now.fr" style={s.a}>support@crush-now.fr</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
